// Libs
import styled, { css } from 'styled-components'

// Comps
import {
  colors,
  forScreensGreaterThanMobileWidth,
  mobileScreen,
  icons,
} from '../../utils'
import { H6 } from '../H6'
import { H1 } from '../H1'
import { backgroundImage, px_par } from '../../utils/styles'
import { CTA } from '../CTA'

export const bowedHeroSectionStyles = css`
  /* display: flex; */
  position: relative;
  overflow: hidden;

  /* Internal Of the section */
  .content {
    /* Fix the missing spacing not being inline 
      * Add spacing to avoid menu
      * because margin above shifts the nav
     */

    ${mobileScreen(css`
      padding-top: 80px;
    `)}
  }

  .background {
    position: absolute;
    left: -20px;
    right: -20px;
    top: 0px;
    bottom: 0px;

    margin-left: auto;
    margin-right: auto;
    max-width: ${(props) => {
      if (props['unlockedWidth'] !== true) {
        return `
          calc(${props['maxWidth'] || 1300}px + 40px)
        `
      }
      return 'calc(100% + 40px)'
    }};

    /* background-size: calc(100% - 40px) auto; */
    overflow: hidden;

    border-bottom-left-radius: 90% 25%;
    border-bottom-right-radius: 90% 25%;

    ${mobileScreen(css`
      top: 80px;
      background-size: cover;
      border-bottom-left-radius: 95% 10%;
      border-bottom-right-radius: 95% 10%;
    `)}

    .bg-image {
      position: absolute;
      left: 20px;
      right: 20px;
      top: 0px;
      bottom: 0px;

      /* background: ${(props) => {
        return `url("${props['bgImage']}")` || colors.backgroundWhite
      }}; */
      ${(props) => {
        return props['bgImage'] !== undefined
          ? `background: url("${props['bgImage']}");`
          : ''
      }}
      ${(props) => {
        return props['bgColor'] !== undefined
          ? `background: ${props['bgColor']};`
          : ''
      }}
      background-position: center;
      background-size: cover;
      background-repeat: no-repeat;
    }

    /* img {
      ${backgroundImage}
      width: calc(100% + 40px);
      height: calc(100% + 40px);
      object-fit: cover;
    } */
  }

  /*  The comp styles */
  .content-container {
    position: relative;
    width: 100%;

    padding-top: ${(props) => {
      return px_par(
        props['maxWidth'] ?? 1300,
        props['maxDynamicPadding'] || 197,
      ) // 197 or (280-100)/2
    }};

    padding-bottom: ${(props) => {
      return px_par(
        props['maxWidth'] ?? 1300,
        props['maxDynamicPadding'] || 197,
      ) // 197
    }};
    /* padding-bottom: ${px_par(1300, 197)}; */

    ${mobileScreen(css`
      /* margin-bottom: 60px; */
      padding-top: ${px_par(375, 140)};
      padding-bottom: ${px_par(375, 140)};
    `)}

    .heroText {
      box-sizing: border-box;
      width: 100%;
      max-width: 589px;

      margin: auto;
      padding: 0 20px;
      position: relative;

      display: flex;
      flex-direction: column;
      align-items: center;

      ${H6} {
        text-align: center;
        color: ${colors.white};
      }

      ${H1} {
        color: ${colors.white};
        text-align: center;
        /* margin-top: ${px_par(1300, 20)}; */
        margin-top: ${(props) => {
          return px_par(props['maxWidth'] ?? 1300, 20) // 197
        }};
      }

      ${CTA} {
        /* margin-top: ${px_par(1300, 45)}; */
        margin-top: ${(props) => {
          return px_par(props['maxWidth'] ?? 1300, 45) // 197
        }};
      }
    }

    .icon-container {
      position: absolute;
      width: 100%;
      bottom: 0px;
      left: 0px;

      /* padding-bottom: ${px_par(1300, 74)}; */
      padding-bottom: ${(props) => {
        return px_par(props['maxWidth'] ?? 1300, 74) // 197
      }};

      display: flex;
      justify-content: center;
      align-items: center;

      ${mobileScreen(
        css`
          display: none;
        `,
      )}

      .heroIconArrow {
        width: 40px;
        height: 40px;

        display: flex;
        justify-content: center;
        align-items: center;

        border-radius: 50%;
        background: ${colors.purple};

        .icon-arrow {
          display: inline-block;
          width: 20px;
          height: 20px;
          background-size: cover;
          background-image: url('/icons/icon-arrow-down.svg');
        }
      }
    }
  }
`
